// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { DistributiveOmit, getObjectKeys, pickKeys } from "@hex-insights/core";
import { EditMode, FormEditModes, FormType, useFormState, UseFormStateArgs } from "@hex-insights/forms";
import * as CourseAssessmentFormValues from "./form-values";

export type UseCreateFormStateArgs<
	K extends keyof CourseAssessmentFormValues.Create = keyof CourseAssessmentFormValues.Create,
> = DistributiveOmit<UseFormStateArgs<CourseAssessmentFormValues.CreateSubset<K>>, "initialFormValues"> & {
	initialFormValues?: Partial<Pick<CourseAssessmentFormValues.Create, K>>;
	fields?: { [Key in CourseAssessmentFormValues.CreateRequiredKey | K]: true };
};

/**
 * Returns a `formState` object for use in the create form for the CourseAssessment model.
 */
export function useCreateFormState<
	K extends keyof CourseAssessmentFormValues.Create = keyof CourseAssessmentFormValues.Create,
>({ initialFormValues, fields, formType = FormType.Create, ...args }: UseCreateFormStateArgs<K> = {}) {
	return useFormState({
		initialFormValues: () => {
			const formValues = { ...CourseAssessmentFormValues.initialCreate, ...initialFormValues };
			return fields ? pickKeys(formValues, getObjectKeys(fields)) : formValues;
		},
		formType,
		...args,
	});
}

const detailFieldEditModes: Partial<FormEditModes<CourseAssessmentFormValues.Detail>> = {
	authorID: EditMode.ReadOnly,
};

export type UseDetailFormStateArgs<
	K extends keyof CourseAssessmentFormValues.Detail = keyof CourseAssessmentFormValues.Detail,
> = UseFormStateArgs<CourseAssessmentFormValues.DetailSubset<K>>;

/**
 * Returns a `formState` object for use in the detail form of the CourseAssessment model.
 *
 * @param initialFormValues The initial values for the form. Generally from
 * {@link CourseAssessmentFormConversion.toFormValues}.
 */
export function useDetailFormState<
	K extends keyof CourseAssessmentFormValues.Detail = keyof CourseAssessmentFormValues.Detail,
>({
	initialFormValues,
	formType = FormType.Update,
	fieldEditModes = detailFieldEditModes,
	...args
}: UseDetailFormStateArgs<K>) {
	return useFormState({ initialFormValues, formType, fieldEditModes, ...args });
}

export type UseReadOnlyFormStateArgs<
	K extends keyof CourseAssessmentFormValues.Detail = keyof CourseAssessmentFormValues.Detail,
> = UseFormStateArgs<CourseAssessmentFormValues.DetailSubset<K>>;

/**
 * Returns a read-only `formState` object for use in the detail form of the CourseAssessment model.
 *
 * @param initialFormValues The initial values for the form. Generally from
 * {@link CourseAssessmentFormConversion.toFormValues}.
 */
export function useReadOnlyFormState<
	K extends keyof CourseAssessmentFormValues.Detail = keyof CourseAssessmentFormValues.Detail,
>({ initialFormValues, formType = FormType.View, ...args }: UseReadOnlyFormStateArgs<K>) {
	return useFormState({ initialFormValues, formType, ...args });
}
